import React, { useEffect } from "react";
import { Footer, Header } from "../components";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import menuIcon3 from "../assets/images/menu-icon3.svg";
import menuIcon6 from "../assets/images/menu-icon6.svg";
import menuIcon8 from "../assets/images/menu-icon8.svg";
import { fixedHeader } from "../values/utils";

const NewsLetter = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 100);
    fixedHeader();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Newletter - Object magazine</title>
        <meta name="description" content={""} />
      </Helmet>
      <Header />
      <main id="main">
        {/* <!--============================== Content Start ==============================--> */}
        <div className="content-container less-pad  pb-0">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-heading">
                  <h1>EXCLUSIVE NEWSLETTERS</h1>
                  <h3>
                    {" "}
                    Written By The Best Journalists In The Country, <br /> Our
                    Newsletters Covers Multiple Subjects.
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--============================== Content End ==============================--> */}
        {/* <!--============================== Content Start ==============================--> */}
        <div className="content-container">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul className="newsletter-list">
                  <li className="newsletter-item">
                    <div className="newsletter-box d-flex flex-wrap bg-success">
                      <div className="newsletter-left">
                        <div className="newsletter-icon">
                          <img loading="lazy" src={menuIcon8} alt="" />
                        </div>
                        <div className="newsletter-cat">Arts and Culture</div>
                      </div>
                      <div className="newsletter-mid">
                        <div className="newsletter-title">
                          <h2> MYTHOS</h2>
                        </div>
                        <div className="newsletter-weekend">
                          WEEKDAYS ON WEDNESDAY
                        </div>
                      </div>
                      <div className="newsletter-right">
                        <div className="newsletter-text">
                          <p>
                            {" "}
                            At Object, we seek to understand culture not as a static museum piece, but as a dynamic conversation. Art is more than image, and culture is more than artifact. We're not just observers. Culture is not a spectator sport—it's a collaborative adventure. We're curious investigators tracking the intricate paths where human imagination, history, and meaning intersect. ‘Mythos’, Object’s Arts and Culture newsletter, peels back layers of cultural complexity, and brings stories to you that reveal how our creative acts are never random, but always deeply connected to the worlds we inhabit. {" "}
                          </p>
                        </div>
                        <div className="newsletter-link">
                          <Link
                            to="/newsletter-arts-and-culture"
                            className="read-more-btn"
                          >
                            Click here to Read More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="newsletter-item">
                    <div className="newsletter-box d-flex flex-wrap bg-muted">
                      <div className="newsletter-left">
                        <div className="newsletter-icon">
                          <img loading="lazy" src={menuIcon3} alt="" />
                        </div>
                        <div className="newsletter-cat">Environment</div>
                      </div>
                      <div className="newsletter-mid">
                        <div className="newsletter-title">
                          <h3> HOT ROCK</h3>
                        </div>
                        <div className="newsletter-weekend">
                          WEEKDAYS ON WEDNESDAY
                        </div>
                      </div>
                      <div className="newsletter-right">
                        <div className="newsletter-text">
                          <p>
                            {" "}
                            We are not passive witnesses to transformation. We are cartographers of change, tracing the intricate intersections where human systems, geological processes, and living ecosystems collide and collaborate. This is a time for profound dialogues between human agency and planetary dynamics. Ecological challenges are never merely scientific phenomena, but deeply cultural experiences—revealing our most fundamental relationships with the living world. ‘Hot Rock’ brings you stories that reimagine our relationship with the environment.{" "}
                          </p>
                        </div>
                        <div className="newsletter-link">
                          <Link
                            to="/newsletter-environment"
                            className="read-more-btn"
                          >
                            Click here to Read More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="newsletter-item">
                    <div className="newsletter-box d-flex flex-wrap bg-secondary">
                      <div className="newsletter-left">
                        <div className="newsletter-icon">
                          <img loading="lazy" src={menuIcon6} alt="" />
                        </div>
                        <div className="newsletter-cat">Sports</div>
                      </div>
                      <div className="newsletter-mid">
                        <div className="newsletter-title">
                          <h4> SERIOUS PLAY</h4>
                        </div>
                        <div className="newsletter-weekend">
                          WEEKDAYS ON WEDNESDAY
                        </div>
                      </div>
                      <div className="newsletter-right">
                        <div className="newsletter-text">
                          <p>
                            {" "}
                            Beyond mere competition, athletics represent a cultural text—a dynamic arena where bodily performance intersects with complex social choreographies of power, identity, and collective imagination. Athletic endeavors are never simply about winning, but about negotiating fundamental human experiences. With ‘Serious Play’ Object brings you stories that trace the nuanced genealogies of athletic expression: from indigenous sporting rituals to global spectacle, from local community practices to transnational performances of collective identity.{" "}
                          </p>
                        </div>
                        <div className="newsletter-link">
                          <Link to="/newsletter-sports" className="read-more-btn">
                            Click here to Read More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* <!--============================== Content End ==============================--> */}
        <Footer />
      </main>
    </div>
  );
};

export default NewsLetter;
